module.exports = __webpack_public_path__ + "static/media/LinkedIn.7f0c960b.svg";